// src/core/utils/cache.ts
export const setCache = (key, data) => {
    const cacheEntry = {
        data,
        timestamp: Date.now(),
    };
    localStorage.setItem(key, JSON.stringify(cacheEntry));
};
export const getCache = (key, maxAge) => {
    const cacheEntryStr = localStorage.getItem(key);
    if (!cacheEntryStr)
        return null;
    const cacheEntry = JSON.parse(cacheEntryStr);
    const isExpired = Date.now() - cacheEntry.timestamp > maxAge;
    if (isExpired) {
        localStorage.removeItem(key);
        return null;
    }
    return cacheEntry.data;
};
